module.exports = __webpack_public_path__ + "static/media/medpro_circle.ea51cd8c.svg";